import { IconButton, InputAdornment, Stack, Typography } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import React, { ChangeEvent } from 'react';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { HEADER_USER_PAGE_FIELD, User } from '../type';
import { useSearchParams } from 'react-router-dom';
import { PagingInfo } from 'types/paging';
import { TableCustom } from 'app/components/elements/TableCustom';

const renderDataMap = (fieldAccess: User[]) => {
  return fieldAccess.map((user) => {
    return {
      name: {
        value: (
          <Stack flexDirection={'row'} alignItems={'center'} gap={'10px'}>
            <img height={'20px'} src={'/icons/icon_user_image.svg'} alt={`profile-img`} />
            <Typography>{user.name}</Typography>
          </Stack>
        )
      },
      email: {
        value: <Typography>{user.email}</Typography>
      },
      role: {
        value: <Typography>{user.role}</Typography>
      },
      actions: {
        value: (
          <Stack flexDirection={'row'} gap={'10px'} alignItems={'center'}>
            <img
              style={{ cursor: 'pointer' }}
              onClick={() => {}}
              src={'/icons/icon_action_edit.svg'}
              alt={`icon_action_edit`}
            />
          </Stack>
        )
      }
    };
  });
};

type FieldAccessTabProps = {
  fieldAccess: User[];
  searchTextClient: string;
  setSearchTextClient?: (value: string) => void;
  handleAddUser: () => void;
  pagingInfo: PagingInfo;
  handleChangePage: (value: number) => void;
};
export const FieldAccessTab = ({
  fieldAccess,
  setSearchTextClient,
  searchTextClient,
  handleAddUser,
  pagingInfo,
  handleChangePage
}: FieldAccessTabProps) => {
  const [searchParams] = useSearchParams();

  return (
    <Stack sx={{ marginTop: '30px' }}>
      <Stack
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px'
        }}>
        <Stack flexDirection={'row'} gap={1.25}>
          <Stack gap={1}>
            <InputText
              startAdornment={
                <InputAdornment position="end">
                  <IconButton>
                    <img alt={'icon-user'} src={'/icons/icon_search.svg'} width={24} />
                  </IconButton>
                </InputAdornment>
              }
              placeholder={'Search'}
              inputProps={{
                value: searchTextClient,
                style: {
                  width: '352px',
                  minHeight: '46px',
                  height: '46px',
                  padding: 0
                },
                onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setSearchTextClient && setSearchTextClient(event.target.value);
                }
              }}
            />
          </Stack>
          <ButtonCustom
            sx={{ width: 'max-content', height: '46px' }}
            label={'Search'}
            onClick={() => {}}
          />
        </Stack>
        <ButtonCustom
          sx={{ width: 'max-content', height: '46px' }}
          label={'Add User'}
          onClick={handleAddUser}
        />
      </Stack>
      <Stack sx={{ marginTop: '30px', marginBottom: '30px' }}>
        <TableCustom
          onSortHeader={() => {}}
          sort={{
            field: searchParams.get('sortBy') || '',
            order: searchParams.get('order') || ''
          }}
          data={renderDataMap(fieldAccess)}
          headers={HEADER_USER_PAGE_FIELD}
          handleChooseRow={() => {}}
          styledTableRow={{ cursor: ' default ' }}
          pagingInfo={pagingInfo}
          handleChangePage={handleChangePage}
        />
      </Stack>
    </Stack>
  );
};
